import {
    faBoxes,
    faCalculator,
    faCog,
    faFileExcel,
    faList,
    faPlus,
    faSearch,
    faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

interface ActionsButtonsProps {
    history: any
    routes: any
    visibleButtons: any
    /** Si se define, reemplaza la navegación a `routes.add` al pulsar Crear */
    onCreateClick?: () => void
    handleImprimir?: () => void
    handleBuscador?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    listaPrecios?: any[]
    listaPrecio?: any
    setListaPrecio?: any
    disabledButton?: boolean
    disabledExportButton?: boolean
    searchCriteria?: string
    setSearchCriteria?: (value: string) => void
    getCriteriaLabel?: () => string
}

const HeaderActionsButtons = ({
    history,
    routes,
    visibleButtons,
    onCreateClick,
    handleImprimir,
    handleBuscador,
    listaPrecios = [],
    listaPrecio = null,
    setListaPrecio,
    disabledButton = false,
    disabledExportButton = false,
    searchCriteria,
    setSearchCriteria,
    getCriteriaLabel,
}: ActionsButtonsProps) => {
    return (
        <div className="d-flex bd-highlight">
            {visibleButtons?.create && (
                <div className="p-2 bd-highlight">
                    <button
                        className="btn btn-outline-success btn-lg"
                        onClick={() => {
                            if (onCreateClick) {
                                onCreateClick()
                                return
                            }
                            if (listaPrecio !== null) {
                                history.push({
                                    pathname: routes.add,
                                    state: {
                                        listaPrecioId: listaPrecio.id,
                                    },
                                })
                            } else {
                                history.push(routes.add)
                            }
                        }}
                    >
                        <FontAwesomeIcon icon={faPlus} /> Crear
                    </button>
                </div>
            )}

            {visibleButtons?.composite && (
                <div className="p-2 bd-highlight">
                    <button
                        className="btn btn-outline-info btn-lg"
                        onClick={() => {
                            history.push(routes.composite)
                        }}
                    >
                        <FontAwesomeIcon icon={faBoxes} /> Compuestos
                    </button>
                </div>
            )}

            {visibleButtons?.articuloPrecio && (
                <div className="p-2 bd-highlight">
                    <button
                        className="btn btn-outline-info btn-lg"
                        onClick={() => {
                            history.push(routes.articuloPrecio)
                        }}
                        disabled={disabledButton}
                    >
                        <FontAwesomeIcon icon={faCalculator} /> Precios
                        Articulos
                    </button>
                </div>
            )}

            {visibleButtons?.import && (
                <div className="p-2 bd-highlight">
                    <button
                        className="btn btn-outline-warning btn-lg"
                        onClick={() => {
                            history.push(routes.import)
                        }}
                    >
                        <FontAwesomeIcon icon={faList} /> Importar
                    </button>
                </div>
            )}

            {visibleButtons?.export && (
                <div className="p-2 bd-highlight">
                    <button
                        className="btn btn-outline-danger btn-lg"
                        onClick={() => handleImprimir?.()}
                        disabled={disabledExportButton}
                    >
                        <FontAwesomeIcon icon={faFileExcel} /> Exportar
                    </button>
                </div>
            )}

            {visibleButtons?.deleted && (
                <div className="p-2 bd-highlight">
                    <button
                        className="btn btn-outline-primary btn-lg"
                        onClick={() => {
                            history.push(routes.deleted)
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} /> Eliminados
                    </button>
                </div>
            )}

            {visibleButtons?.search && (
                <div className="p-2 flex-grow-1 bd-highlight">
                    <div className="input-group input-group-lg">
                        <div className="input-group-prepend">
                            <span
                                className="input-group-text"
                                id="inputGroupPrepend"
                            >
                                <FontAwesomeIcon icon={faSearch} />
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control form-lg"
                            id="inputNombre"
                            name="precio"
                            placeholder={getCriteriaLabel ? `Buscar por ${getCriteriaLabel().toLowerCase()}...` : 'Buscar'}
                            onKeyPress={(e) => handleBuscador?.(e)}
                        />
                        {searchCriteria != null && setSearchCriteria && getCriteriaLabel ? (
                            <div className="input-group-append">
                                <div className="input-group-prepend">
                                    <button
                                        className="btn btn-outline-secondary dropdown-toggle"
                                        type="button"
                                        id="dropdownSearchCriteriaArticulos"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        title={`Criterio actual: ${getCriteriaLabel()}`}
                                    >
                                        <FontAwesomeIcon color="black" icon={faCog} />
                                    </button>
                                    <div
                                        className="dropdown-menu dropdown-menu-right"
                                        aria-labelledby="dropdownSearchCriteriaArticulos"
                                    >
                                        <button
                                            type="button"
                                            className={`dropdown-item ${searchCriteria === 'nombre' ? 'active' : ''}`}
                                            onClick={() => setSearchCriteria('nombre')}
                                        >
                                            Nombre
                                        </button>
                                        <button
                                            type="button"
                                            className={`dropdown-item ${searchCriteria === 'codigo' ? 'active' : ''}`}
                                            onClick={() => setSearchCriteria('codigo')}
                                        >
                                            Código
                                        </button>
                                        <button
                                            type="button"
                                            className={`dropdown-item ${searchCriteria === 'codigoBarra' ? 'active' : ''}`}
                                            onClick={() => setSearchCriteria('codigoBarra')}
                                        >
                                            Código de Barra
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            )}

            {visibleButtons?.listas && (
                <div className="p-2 bd-highlight">
                    <div className="dropdown">
                        <button
                            className="btn btn-outline-danger btn-lg dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <FontAwesomeIcon icon={faList} />{' '}
                            {`${listaPrecio?.nombre || 'Seleccione lista de precio'}`}
                        </button>
                        <div
                            className="dropdown-menu dropdown-menu-right"
                            aria-labelledby="dropdownMenuButton"
                        >
                            {listaPrecios.map((lista) => {
                                return (
                                    <button
                                        key={lista.id}
                                        className="dropdown-item"
                                        onClick={() => setListaPrecio(lista)}
                                    >
                                        {lista.nombre}
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default HeaderActionsButtons
